import { atom } from 'jotai';

const isTradeUserSidebarOpenAtom = atom(false);

export default isTradeUserSidebarOpenAtom;
